import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"
const skeletonVariants = cva("animate-pulse rounded-md ", {
  variants: {
    variant: {
      default: "bg-primary/10",
      secondary: "bg-primary/30",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})
interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}
function Skeleton({ className, variant, ...props }: SkeletonProps) {
  return (
    <div className={cn(skeletonVariants({ variant }), className)} {...props} />
  )
}
export { Skeleton }
